
import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import {
  getAvailablePackageList, getClientProductRequest, getInvoiceDetail, getPackageById, getPackageByPackageId,
  getPackageServiceIdRequest, getUpgradablePackagesRequest, getUserInvoices, postActivePackage, postUpdatePackage, upgradePackageRequest
} from '../apiRequests/packageRequest'

function* getPackageByIdHandler(action) {
  try {
    const response = yield call(getPackageById, action.params, action.userId)
    yield put({
      type: types.GET_PACKAGE_LIST_BY_USER_ID_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_PACKAGE_LIST_BY_USer_ID_ERROR,
      action: error,
    })
  }
}

function* activePackageHandler(action) {
  try {
    const response = yield call(postActivePackage, action.params)
    yield put({
      type: types.ACTIVE_PACKAGE_FOR_USER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.ACTIVE_PACKAGE_FOR_USER_ERROR,
      error: error,
    })
  }
}


function* getAvailablePackagesHandler(action) {
  try {
    const response = yield call(getAvailablePackageList, action.params)
    yield put({
      type: types.AVAILABLE_PACKAGE_LIST_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.AVAILABLE_PACKAGE_LIST_ERROR,
      error: error,
    })
  }
}


function* getUserInvoiceDetailHandler(action) {
  try {
    const response = yield call(getInvoiceDetail, action.params)
    yield put({
      type: types.GET_USER_INVOICE_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_USER_INVOICE_ERROR,
      error: error,
    })
  }
}


function* getUserInvoicesHandler(action) {
  try {
    const response = yield call(getUserInvoices, action.params)
    yield put({
      type: types.GET_USER_INVOICES_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_USER_INVOICES_ERROR,
      error: error,
    })
  }
}


function* postUpdatePackageHandler(action) {
  try {
    const response = yield call(postUpdatePackage, action.params)
    yield put({
      type: types.UPDATE_PACKAGE_REQUEST_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_PACKAGE_REQUEST_ERROR,
      error: error,
    })
  }
}


function* getPackageByPackageIdHandler(action) {
  try {
    const response = yield call(getPackageByPackageId, action.params)
    yield put({
      type: types.GET_PACKAGE_BY_ID_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_PACKAGE_BY_ID_ERROR,
      error: error,
    })
  }
}



function* getUpgradablePackagesHandler(action) {
  try {
    const response = yield call(getUpgradablePackagesRequest, action.params)
    yield put({
      type: types.GET_UPGRADABLE_PACKAGES_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_UPGRADABLE_PACKAGES_ERROR,
      error: error,
    })
  }
}

function* getPackageServiceIdHandler(action) {
  try {

    const response = yield call(getPackageServiceIdRequest, action.params)
    yield put({
      type: types.GET_PACKAGE_SERVICE_ID_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_PACKAGE_SERVICE_ID_ERROR,
      error: error,
    })
  }
}

function* getClientProductHandler(action) {
  try {
    const response = yield call(getClientProductRequest, action.params)
    yield put({
      type: types.GET_CLIENT_PRODUCT_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_CLIENT_PRODUCT_ERROR,
      error: error,
    })
  }
}

function* upgradePackageHandler(action) {
  try {
    const response = yield call(upgradePackageRequest, action.params)
    yield put({
      type: types.GET_UPGRADE_PACKAGE_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_UPGRADE_PACKAGE_ERROR,
      error: error,
    })
  }
}



function* watcherAllPackagesSaga() {
  yield takeEvery(types.GET_PACKAGE_LIST_BY_USER_ID_REQUEST, getPackageByIdHandler)
  yield takeEvery(types.ACTIVE_PACKAGE_FOR_USER_REQUEST, activePackageHandler)
  yield takeEvery(types.AVAILABLE_PACKAGE_LIST_REQUEST, getAvailablePackagesHandler)
  yield takeEvery(types.GET_USER_INVOICE_REQUEST, getUserInvoiceDetailHandler)
  yield takeEvery(types.GET_INVOICELIST_REQUEST, getUserInvoicesHandler)
  yield takeEvery(types.UPDATE_PACKAGE_REQUEST, postUpdatePackageHandler)
  yield takeEvery(types.GET_PACKAGE_BY_ID_REQUEST, getPackageByPackageIdHandler)
  yield takeEvery(types.GET_UPGRADABLE_PACKAGES_REQUEST, getUpgradablePackagesHandler)
  yield takeEvery(types.GET_PACKAGE_SERVICE_ID_REQUEST, getPackageServiceIdHandler)
  yield takeEvery(types.GET_CLIENT_PRODUCT_REQUEST, getClientProductHandler)
  yield takeEvery(types.GET_UPGRADE_PACKAGE_REQUEST, upgradePackageHandler)







}

export default watcherAllPackagesSaga